import Product from '~/models/Product/Product'
import { minimizeProduct } from '~/utils/minimizeProduct'

export const minimizeProductArray = (products: Product[]) => {
    if (!products) {
        return []
    }

    return products.map((inputProduct) => {
        return minimizeProduct(inputProduct)
    })
}
